<template>
  <svg :width="width" :height="height" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24.5812 10.0836L20.9083 4.7778C20.636 4.38538 20.2742 4.06349 19.8527 3.83879C19.4313 3.6141 18.9624 3.49307 18.4848 3.48574L11.5144 3.38574H11.5C7.90131 3.38574 5.14019 3.98768 3.36188 6.92537C1.70625 9.65987 1 14.3179 1 22.5004V23.5004H3.28481L1.814 31.0004H3.85212L5.32294 23.5004H6C7.63323 23.515 9.20667 22.8866 10.3805 21.7509C11.4417 20.7356 12.2071 19.3464 12.5942 17.7338L12.5977 17.7193L14.3129 9.50043H12.2697L10.6461 17.2809C10.1516 19.3234 8.67287 21.5004 6 21.5004H3.00375C3.05806 14.4213 3.70263 10.2242 5.07281 7.9608C6.22281 6.0608 7.90375 5.38637 11.4931 5.38543L18.4561 5.48543C18.6152 5.48787 18.7716 5.52821 18.912 5.60311C19.0525 5.67801 19.1731 5.78531 19.2639 5.91612L23.4188 11.9173L29 12.8476V13.9075L28.0693 18.8713C27.7946 20.3364 27.325 21.0744 25.3994 21.3057L17.5053 22.6562L17.4531 31.0004H19.4531L19.4947 24.3446L25.6635 23.2884C27.061 23.1166 28.0921 22.6662 28.8151 21.9119C29.4333 21.2671 29.8094 20.4432 30.0351 19.2399L31 14.0934V11.1533L24.5812 10.0836Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'DogIcon',
  props: {
    width: {
      type: Number,
      default: 32,
    },
    height: {
      type: Number,
      default: 32,
    },
    color: {
      type: String,
      default: '#4B4C52',
    },
  },
};
</script>
